function trimSlash(value) {
  return String(value || '').replace(/\/$/, '');
}

export const DEFAULT_API_ORIGIN = 'https://ping-talk-server.onrender.com';

function normalizeHost(hostname) {
  return String(hostname || '').trim().toLowerCase().replace(/\.$/, '').replace(/^\[|\]$/g, '');
}

export function isLocalDevHost(hostname) {
  const host = normalizeHost(hostname);
  return host === ''
    || host === 'localhost'
    || host === '127.0.0.1'
    || host === '0.0.0.0'
    || host === '::1'
    || host.endsWith('.localhost');
}

function originHostname(value) {
  try {
    return normalizeHost(new URL(value).hostname);
  } catch {
    return '';
  }
}

function isPulseTalkWebHost(hostname) {
  const host = normalizeHost(hostname);
  return host === 'pulsetalk.app' || host === 'www.pulsetalk.app';
}

const SIGNALING_HOSTNAME = originHostname(DEFAULT_API_ORIGIN);

// pulsetalk.app and any other static publish host have no /api routes.
function pointsAtStaticSite(host, pageHost) {
  if (!host || host === SIGNALING_HOSTNAME) return false;
  if (isPulseTalkWebHost(host)) return true;
  return Boolean(pageHost) && host === pageHost;
}

export function resolveEndpoints({
  apiUrl = '',
  wsUrl = '',
  wsParam = '',
  hostname = '',
  protocol = 'https:',
} = {}) {
  const pageHost = normalizeHost(hostname);
  const pageIsLocal = isLocalDevHost(pageHost);

  let apiOrigin = trimSlash(apiUrl);
  const apiHost = originHostname(apiOrigin);
  if (!pageIsLocal && (!apiOrigin || isLocalDevHost(apiHost) || pointsAtStaticSite(apiHost, pageHost))) {
    apiOrigin = DEFAULT_API_ORIGIN;
  }

  let resolvedWs = wsParam || wsUrl;
  const wsHost = originHostname(resolvedWs);
  if (!wsParam && resolvedWs && !pageIsLocal && (isLocalDevHost(wsHost) || pointsAtStaticSite(wsHost, pageHost))) {
    resolvedWs = '';
  }
  if (!resolvedWs && apiOrigin) {
    const url = new URL(apiOrigin);
    url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
    url.pathname = '';
    url.search = '';
    url.hash = '';
    resolvedWs = url.origin;
  }
  if (!resolvedWs) {
    const wsProtocol = protocol === 'https:' ? 'wss:' : 'ws:';
    resolvedWs = `${wsProtocol}//${hostname}`;
  }

  return { apiOrigin, wsUrl: resolvedWs };
}

const resolved = resolveEndpoints({
  apiUrl: import.meta.env.VITE_API_URL,
  wsUrl: import.meta.env.VITE_WS_URL,
  wsParam: typeof window === 'undefined' ? '' : new URLSearchParams(window.location.search).get('ws'),
  hostname: typeof window === 'undefined' ? '' : window.location.hostname,
  protocol: typeof window === 'undefined' ? 'http:' : window.location.protocol,
});

export const API_ORIGIN = resolved.apiOrigin;
export const WS_URL = resolved.wsUrl;
